/**
 * Created by pmnia on 14/05/2017.
 */


(function(){
    angular.module('app.widgets')
        .directive('obtBookingButton',obtBookingButton);


    function obtBookingButton(){
        return {
            restrict:'A',
            bindToController:true,
            scope:{
                // maxItem:'@',
                model:'=?',
                closeCallback:'&?'
            },
            template: '<form class="form-inline">\n    <span ng-show="vm.range" class="form-group booking-button-quantity">\n        <select class="form-control" name="quantity" id="quantity" ng-model="q" ng-options=" v for v in vm.range">\n        <option value="">- Quantity -</option>\n        </select>\n    </span>\n    <button type="submit" class="btn btn-sm btn-default" ng-click="vm.bookItem(q)" ng-transclude>{{vm.title | translate}}</button>\n\n    <obt-modal-popup\n            title=\'Add a booking for a client\'\n            open-modal-promise=\'vm.showSingleBookingForm\'\n            template-url=\'app/booking/add.html\'\n            template-controller=\'BookingController as vmModal\'>\n        <obt-modal-popup-choice\n                template-condition-name="allDayType"\n                template-condition-value="onRequest"\n                template-url=\'app/booking/requestBooking.html\'\n                template-controller=\'BookingController as vmModal\'>\n        </obt-modal-popup-choice>\n        <obt-modal-popup-choice\n                template-condition-name="allDayType"\n                template-condition-value="NA"\n                template-url=\'app/booking/addToWaitingList.html\'\n                template-controller=\'BookingController as vmModal\'>\n        </obt-modal-popup-choice>\n    </obt-modal-popup>\n</form>',
            link: function(scope, element, attrs, $ctrl) {

                element.on('click', function(e) {
                    e.stopPropagation(); //stop event from bubbling up to document object
                    $ctrl.bookItem();
                });

            },
            controller: /*@ngInject*/function(obtModalService){
                var vm = this;

                // vm.range = [];
                // vm.title = 'BOOK_NOW';
                // vm.maxItem = parseInt(vm.maxItem);
                // for(i=1; i <= vm.maxItem; i++){
                //     vm.range.push(i)
                // }
                // console.log('directive to debyg', $scope.maxItem, vm.maxItem, vm.range  );

                vm.bookItem = function(quantity){
                    var model = angular.extend(
                        {
                            'allDay' : true,
                            'allDayType' : "onRequest",
                            'title' : "Reqest Appointment",
                            'description' : "Réservation en ligne"
                        },
                        vm.model);

                    vm.showSingleBookingForm(model, vm.closeCallback);
                }

                vm.showSingleBookingForm = function (model, closeCallback){
                    var settings = getModalSettings(model);
                    return obtModalService.openModal(settings).result.then(modalClosed);
                    console.log('TESY', model)
                }

                function getModalSettings(calEvent, closeCallback){
                    var settings = {
                        templateUrl: 'app/blocks/modal/obt-modals.directive.html',
                        controller:'modalsController',
                        controllerAs: 'vmModalPopups'
                    };

                    settings.resolve = settings.resolve ? settings.resolve : {};
                    settings.resolve.modalModel = function(){return calEvent};
                    settings.resolve.modalSettings = function(){
                        return {
                            closeCallback: closeCallback,
                            options:modalOptions,
                            title:$scope.title
                        }};

//                    settings.callbackSuccess = callbackSuccess;
                    settings.callbackFailed = callbackFailed;

                    return settings;
                }

                function getModalSettings(model, success, fail){
                    // set default value
                    var templateUrl = vm.templateUrl || 'app/booking/requestBooking.html';
                    var templateController = vm.templateController || 'BookingController as vmModal';

                    // //check if a choice is valid
                    // if (modalChoices && model) {
                    //     var firstMatchingChoice = modalChoices.filter(function(item){
                    //         return item && item.templateConditionName != null ? String(model[item.templateConditionName]) == item.templateConditionValue : false;
                    //     }).shift();
                    //
                    //     console.log(firstMatchingChoice);
                    //
                    //     if(firstMatchingChoice){
                    //         templateUrl = firstMatchingChoice.templateUrl ? firstMatchingChoice.templateUrl : templateUrl;
                    //         templateController = firstMatchingChoice.templateController ? firstMatchingChoice.templateController : templateController;
                    //     }
                    // }

                    var settings = {
                        templateUrl:templateUrl,
                        controller:templateController
                    };

                    vm.usedModalModel = ! angular.isUndefined(model) ? model : vm.modalModel;
                    settings.resolve = settings.resolve ? settings.resolve : {};
                    settings.resolve.modalModel = getSelectedModalModel;

                    settings.callbackSuccess = success || callbackSuccess;
                    settings.callbackFailed = fail || success || callbackFailed;
                    return settings;
                }
            },
            controllerAs:'vm'
        };

    }


})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/obt-booking-button.directive.js
 ** module id = 195
 ** module chunks = 0
 **/